import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/** Instagram Feed on mobile ("Sažetak na Instagramu za mobilne uređaje"). */
@Component({
  selector: 'app-meta-instagram-feed-mobile',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './instagram-feed-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../../preview-common/instagram/instagram-feed-styles.scss']
})
export class MetaInstagramFeedMobilePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly accountName = MetaPreviewCopy.INSTAGRAM_ACCOUNT_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** Two lines of caption, the username included, before "... more" (77 characters on the mock). */
  get caption(): TruncatedCopy {
    return MetaPreviewCopy.caption(this.accountName, MetaPreviewCopy.primaryText(this.data), 77);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
